import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';

import { ApplicationConfigService, BaseContainer, DialogConfig, DialogRef } from '@stylehaven/components';

@Component({
    selector: 'med-batch-limit-dialog',
    templateUrl: './batch-limit-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BatchLimitDialogComponent extends BaseContainer {
    public readonly yesKey: string = 'actions.common.cancel';
    public readonly messageKey: string = 'batches.batch-limit.warning';
    public readonly followMessageKey: string = 'batches.batch-limit.watch-in-management';
    public readonly managementKey: string = 'dashboard.external-links.management';

    @HostListener('document:keydown.enter', ['$event'])
    handleEnter(event: KeyboardEvent) {
        this.submit();
    }

    constructor(
        public config: DialogConfig,
        public dialog: DialogRef<void>,
        private readonly configService: ApplicationConfigService
    ) {
        super();
    }

    public submit(): void {
        this.dialog.close();
    }

    public get batchesLink(): string {
        const link = this.configService.getInstant('managementAppUrl');
        if (link) {
            return `${link.replace(/\/$/, '')}/batches`;
        }
        return '';
    }
}
